var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputComponent',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},'InputComponent',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }